import * as types from "./types";
import createReducer from "../../utils/createReducer";
import { parseMessagesList } from "../../utils/common";

const initialHistoryChat = {
  items: [],
  current_page: 0,
  isTheEndPage: false,
};

const initialState = {
  items: [],
  historyChat: initialHistoryChat,
  countMembersInRoom: 0,
  bothInCall: 0,
  isVideoCall: false,
  isAudioCall: false,
  // DS-1745: the patient's camera on/off state, driven by cameraState
  // call messages; true by default so old clients that never send the
  // event keep rendering exactly as before.
  remoteCameraEnabled: true,
  isRejected: false,
  isNeedScrolling: false,
  connectChatStatus: "disconnected",
};

const chatReducer = createReducer(initialState)({
  [types.GET_CHAT_MESSAGES_TEMPLATES]: (state, { data }) => {
    return {
      ...state,
      templatesItems: data?.items || [],
    };
  },

  [types.SET_CHAT_HISTORY]: (state, { historyChat, current_page, isTheEndPage }) => {
    return {
      ...state,
      historyChat: {
        items: parseMessagesList(historyChat, state.historyChat.items),
        current_page,
        isTheEndPage,
      },
    };
  },

  [types.SET_NEW_MESSAGE]: (state, { message }) => {
    return {
      ...state,
      historyChat: {
        ...state.historyChat,
        items: parseMessagesList([message], state.historyChat.items),
      },
    };
  },

  [types.SET_TOTAL_CHAT_MEMBERS]: (state, { countMembersInRoom }) => ({
    ...state,
    countMembersInRoom,
  }),

  [types.IS_READ_MESSAGES_LIST]: (state, { idsList }) => {
    const items = state.historyChat.items.map((item) => ({
      ...item,
      list: item.list.map((_) => ({
        ..._,
        status: idsList.includes(_._id) ? 2 : _.status,
      })),
    }));
    return {
      ...state,
      historyChat: {
        ...state.historyChat,
        items,
      },
    };
  },
  [types.CLEAR_HISTORY_CHAT]: (state) => ({
    ...state,
    historyChat: { items: [] },
  }),
  [types.REMOVE_CHAT_MESSAGE]: (state, { messageId }) => {
    const newList = state.historyChat.items.map(({ date, list }) => ({
      date,
      list: list.filter((item) => item._id !== messageId),
    }));

    return {
      ...state,
      historyChat: {
        ...state.historyChat,
        items: newList,
      },
    };
  },
  [types.CHANGE_CHAT_MESSAGE]: (state, { messageId, message }) => {
    const newList = state.historyChat.items.map((el) => {
      return {
        ...el,
        list: el.list.map((item) => item._id === messageId ? ({
          ...item,
          message,
        }) : item),
      };
    });
    console.log("NEW LISTSSSSS", newList);

    return {
      ...state,
      historyChat: {
        ...state.historyChat,
        items: [...newList],
      },
    };
  },
  [types.START_AUDIO_CALL]: (state) => ({ ...state, isAudioCall: true }),
  [types.START_VIDEO_CALL]: (state) => ({
    ...state,
    isVideoCall: true,
    remoteCameraEnabled: true,
  }),
  [types.RESET_CALL]: (state) => ({
    ...state,
    isVideoCall: false,
    isAudioCall: false,
    remoteCameraEnabled: true,
  }),
  [types.SET_REMOTE_CAMERA_STATE]: (state, { payload }) => ({
    ...state,
    remoteCameraEnabled: payload,
  }),
  [types.END_AUDIO_CALL]: (state) => ({ ...state, isAudioCall: false }),
  [types.END_VIDEO_CALL]: (state) => ({ ...state, isVideoCall: false }),
  [types.SET_REJECTED]: (state, { payload }) => ({
    ...state,
    isRejected: payload,
  }),
  [types.SET_NEED_SCROLLING]: (state, { payload }) => ({
    ...state,
    isNeedScrolling: payload,
  }),
  [types.CHANGE_CONNECT_STATUS_CHAT]: (state, action) => ({
    ...state,
    connectChatStatus: action.payload.status,
  }),
});

export default chatReducer;
